// @ts-nocheck
const serviceListSliderModule: any =
  serviceListSliderModule ||
  (() => {
    const status = {
      isInitialized: false,
    };

    const classNamePrefix = "fm-o-service-list-slider";

    const setUp = () => {
      const elements = document.querySelectorAll(`.${classNamePrefix}`)
      const breakpoints = {
        tablet: document.body.style.getPropertyValue("--breakpoint-tablet"),
        desktop: document.body.style.getPropertyValue("--breakpoint-desktop")
      }

      if (elements.length === 0) return;

      elements.forEach(el => {
        const swiper = el.querySelector('.swiper')
        if (!swiper) return
        const swiperSpaceBetween = window.getComputedStyle(el).getPropertyValue("--swiper-spaceBetween")
        new Swiper(swiper, {
          slidesPerView: 'auto',
          grid: {
            rows: 2,
          },
          spaceBetween: parseInt(swiperSpaceBetween),
          breakpoints: {
            [breakpoints.desktop]: {
              enabled: false,
              grid: undefined,
              spaceBetween: undefined
            }
          }
        })
      })
    };

    const init = () => {
      if (status.isInitialized) return;
      setUp();
      status.isInitialized = true;
    };
    return {
      init,
    };
  })();

window.addEventListener("load", serviceListSliderModule.init);
